import { render, staticRenderFns } from "./SourceInformation.vue?vue&type=template&id=47c1dc05&scoped=true&"
import script from "./SourceInformation.vue?vue&type=script&lang=js&"
export * from "./SourceInformation.vue?vue&type=script&lang=js&"
import style0 from "./SourceInformation.vue?vue&type=style&index=0&id=47c1dc05&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c1dc05",
  null
  
)

export default component.exports